<template>
  <section class="temp-block px-3 px-md-0 py-3">
    <div class="d-flex flex-wrap px-0 pl-md-3 pr-md-5 justify-content-between">
      <div class="col-12 col-lg-7 px-0 order-2 order-lg-1">
        <div class="img"></div>
      </div>
      <!-- na mobile text pred obrázkom, aby sa nestretli dva obrázky za sebou -->
      <div class="col-12 col-lg-5 px-0 pl-lg-5 py-lg-5 mb-3 mb-lg-0 order-1 order-lg-2">
        <h2 class="mb-5" v-html="$t('Nová etapa v predaji: <br>Bory Nové Bloky')"></h2>
        <p class="mb-4">{{ $t('Vyberte si z novej ponuky bytov v etape Bory Nové Bloky a spoznajte výhody projektu. Projekt sa nachádza v priamej blízkosti Nákupného centra Bory Mall a teda v samotnom centre štvrte Bory s plnohodnotnou občianskou vybavenosťou na skok.') }}</p>
        <BenefitTiles :items="benefits" variant="grey" class="mb-4" />
        <b-button to="/byvanie/nove-bloky" squared variant="primary">{{ $t('Zistiť viac') }}</b-button>
      </div>
    </div>
  </section>
</template>

<script>
import BenefitTiles from "@/components/shared/BenefitTiles";

export default {
  name: "HomeNoveBloky",
  components: {BenefitTiles},
  data() {
    return {
      benefits: [
        { icon: 'inflacia', label: 'Bez inflačnej doložky' },
        { icon: 'parking', label: 'Nájom parkingu <br>s opciou kúpy' },
        { highlight: '10/90', label: 'Financovanie 10/90' },
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
$md: 768px
.temp-block
  background: var(--darkBlue)
  h2
    margin-bottom: 0
    @media (max-width: $md)
      margin-bottom: 30px
  .img
    width: 100%
    height: 100%
    min-height: 400px
    background: url("../../assets/video/header_bloky_thumb.jpg") no-repeat center
    background-size: cover
    @media (max-width: $md)
      min-height: 250px
</style>
